export default __webpack_public_path__ + "static/media/FH_HIN_logo_01.9b4eacff.png";